var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2087_4625)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2087_4625",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2087_4625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 15.8333V14.1666H8.24992C7.37492 14.1666 6.6145 13.8888 5.96867 13.3333C5.32284 12.7777 4.99992 12.0833 4.99992 11.2499C4.99992 10.4166 5.32284 9.72217 5.96867 9.16658C6.6145 8.611 7.37492 8.33325 8.24992 8.33325H13.4999L11.3333 10.4999L12.4999 11.6666L16.6666 7.49992L12.4999 3.33325L11.3333 4.49992L13.4999 6.66659H8.24992C6.90269 6.66659 5.74644 7.10408 4.78117 7.97908C3.81589 8.85408 3.33325 9.94433 3.33325 11.2499C3.33325 12.5555 3.81589 13.6458 4.78117 14.5208C5.74644 15.3958 6.90269 15.8333 8.24992 15.8333H14.1666Z",
    fill: "#94A3B8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2087_4625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/Redo.73708558747b97d16be4448feae372ca.svg";
export { ForwardRef as ReactComponent };